import script from "./ProjectWorkAnalysis.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectWorkAnalysis.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectWorkAnalysis.vue?vue&type=style&index=0&id=20eca3fc&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20eca3fc"]])

export default __exports__